import { render, staticRenderFns } from "./ExpensesTable.vue?vue&type=template&id=d6ecdee2&scoped=true"
import script from "./ExpensesTable.vue?vue&type=script&lang=js"
export * from "./ExpensesTable.vue?vue&type=script&lang=js"
import style0 from "./ExpensesTable.vue?vue&type=style&index=0&id=d6ecdee2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ecdee2",
  null
  
)

export default component.exports